import { useQuery } from "@apollo/client";
import { GET_READ_UNREAD_PERSONS } from "../api/get-read-unread-persons";
import { PersonConfirmationFilter } from "gql/graphql";
import { usePagination } from "@/shared/navigation/pagination";

export function useReadUnreadPersons({
  id,
  filter,
}: {
  id: string;
  filter: PersonConfirmationFilter | null;
}) {
  const { pageRequest, getTablePaginationConfig } = usePagination({
    filter,
  });
  const { data, previousData, loading } = useQuery(GET_READ_UNREAD_PERSONS, {
    variables: { id, filter, pageRequest },
  });

  const records =
    data?.getCompanyDocumentById.personsConfirmationInfo.content ??
    previousData?.getCompanyDocumentById.personsConfirmationInfo.content ??
    [];

  const total =
    data?.getCompanyDocumentById.personsConfirmationInfo.total ??
    previousData?.getCompanyDocumentById.personsConfirmationInfo.total ??
    0;

  return {
    records,
    pagination: getTablePaginationConfig(total),
    loading,
    readConfirmationType:
      data?.getCompanyDocumentById.readConfirmationType ??
      previousData?.getCompanyDocumentById.readConfirmationType,
    confirmationInfo: {
      read: data?.getCompanyDocumentById.confirmationInfoCount.read ?? 0,
      unread: data?.getCompanyDocumentById.confirmationInfoCount.unread ?? 0,
    },
  };
}
